import React, { useEffect, useState } from 'react';
import './WorkspaceDetails.css';
import { MdKeyboardBackspace } from 'react-icons/md';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import GroupAvatar from '../../../Components/GroupAvatar/GroupAvatar';
import { FaRegUserCircle } from 'react-icons/fa';
import WorkspacesDetailsData from './WorkspaceDetailsData/WorkspacesDetailsData';
import WorkspacesDetailsAction from './WorkspaceDetailsAction/WorkspacesDetailsAction';
import WorkspacesDetailsHistory from './WorkspacesDetailsHistory/WorkspacesDetailsHistory';
import TabsOn from '../../../Components/Tabs/Tabs';
import FolderAction from './WorkspaceDetailsAction/FolderAction/FolderAction';
import DataDetailsFolder from './WorkspaceDetailsData/DataDetailsFolder/DataDetailsFolder';
import DataDetailsOutFolder from './WorkspaceDetailsData/DataDetailsOutFolder/DataDetailsOutFolder';
import AddMembers from './AddMembers/AddMembers';
import { PiMagicWandLight } from 'react-icons/pi';
import { HiOutlineDocumentDuplicate } from 'react-icons/hi2';
import { HiOutlineInformationCircle } from 'react-icons/hi2';
import { HiOutlineClipboardDocumentList } from 'react-icons/hi2';
import { Drawer, Popover } from 'antd';
import RequestCredit from './RequestCredit/RequestCredit';
import { BiSolidCoinStack } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import { workspaces_Details_ActionHandler } from '../../../Redux/Actions/user/WorkspaceDetails';
import { workspaces_FolderList_ActionHandler } from '../../../Redux/Actions/user/WorkspaceFolderList';
import {
    workspaces_Quick_ActionHandler,
    workspaces_Quick_Action_ListHandler,
} from '../../../Redux/Actions/user/WorkspaceQuickList';
import { workspaces_Support_Documents_ActionHandler } from '../../../Redux/Actions/user/WorkspaceSupportingDocumentList';
import { workspaces_Support_Documents_OutputList_ActionHandler } from '../../../Redux/Actions/user/WorkspaceSupportingDocumentList';

const dollerIcon = '/assets/Dollersend.svg';
const WorkspaceDetails = () => {
    let dispatch = useDispatch();
    let Navigate = useNavigate();
    // const { search } = useLocation();
    // const queryParams = new URLSearchParams(search);
    // const workspace_id = queryParams?.get("id");
    // const workspace_name = queryParams?.get("name");
    const parms = useParams();
    const workspace_id = parms.id;
    const workspace_name = parms.name;
    const [viewActionWorkspace, setViewActionWorkspace] = useState(false);
    const [viewDataWorkspace, setViewDataWorkspace] = useState(false);
    const [viewDataOutWorkspace, setViewDataOutWorkspace] = useState(false);
    const [openRequestCredit, setOpenRequestCredit] = useState(false);
    const [setDatadetalisid, setDataDetalisId] = useState(null);
    const [setDatadetalisoutputid, setDataDetalisOutPutId] = useState(null);
    const [setViewActionWorkspaceid, setViewActionWorkspaceId] = useState(null);
    const [setworkspacefoldername, setWorkspaceFolderName] = useState(null);
    const [isOpenAddMemberPopup, setIsOpenAddMemberPopup] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const requestData = 0;
    const workspaceSupportingDocumentOutputDetailsData = useSelector(
        (state) =>
            state?.workspaces_Supporting_Document_FolderList_Data
                ?.workspace_supporting_document_folderList_data
    );

    const workspaceSupportingDocumentDetailsData = useSelector(
        (state) =>
            state?.workspaces_Supporting_Document_FolderList_Data
                ?.workspace_supporting_documentlist_data
    );
    const workspaceDetailsData = useSelector(
        (state) => state?.workspaces_Details_Data?.workspace_details_data?.data
    );

    const workspaceFolderListData = useSelector(
        (state) => state?.workspaces_FolderList_Data?.workspace_folderList_data
    );

    const workspaceQuickListData = useSelector(
        (state) => state?.workspaces_QuickList_Data?.workspace_quickList_data
    );

    const workspaceFolderListLoader = useSelector(
        (state) => state?.workspaces_FolderList_Data?.workspace_folderList_data
    );

    const workspaceFoldeCreate = useSelector(
        (state) =>
            state?.workspaces_folder_create_Data?.workspace_folder_create_data
    );

    useEffect(() => {
        if (!isOpenAddMemberPopup) {
            dispatch(workspaces_Details_ActionHandler(workspace_id));
        }
    }, [isOpenAddMemberPopup]);

    useEffect(() => {
        if (workspaceFoldeCreate) {
            dispatch(workspaces_FolderList_ActionHandler(workspace_id, '', ''));
        }
        // eslint-disable-next-line
    }, [workspaceFoldeCreate]);

    useEffect(() => {
        setOpenRequestCredit(false);
    }, []);
    useEffect(() => {
        if (workspace_id && workspace_name) {
            dispatch(workspaces_Details_ActionHandler(workspace_id));
            dispatch(workspaces_FolderList_ActionHandler(workspace_id, '', ''));
            dispatch(
                workspaces_Support_Documents_ActionHandler(workspace_id, '', '')
            );
            dispatch(
                workspaces_Support_Documents_OutputList_ActionHandler(
                    workspace_id,
                    '',
                    ''
                )
            );
            dispatch(
                workspaces_Quick_ActionHandler(
                    workspace_id,
                    '',
                    '',
                    currentPage
                )
            );
        }
        //eslint-disable-next-line
    }, [workspace_id, workspace_name]);

    const tabNames = [
        { name: 'Actions', Icon: <PiMagicWandLight /> },
        { name: 'Data', Icon: <HiOutlineDocumentDuplicate /> },
        { name: 'History', Icon: <HiOutlineClipboardDocumentList /> },
    ];

    const CreditOverlay = () => {
        setOpenRequestCredit(false);
        setOpenRequestCredit(!openRequestCredit);
    };
    const handleClick = (value, id, fname) => {
        console.log('fname', fname);
        setViewDataWorkspace(value);
        setDataDetalisId(id);
        setWorkspaceFolderName(fname);
    };

    const handleClickOutPut = (value, id, fname) => {
        setViewDataOutWorkspace(value);
        setDataDetalisOutPutId(id);
        setWorkspaceFolderName(fname);
    };

    const handleViewActionWorkspaceClick = (value, id, folder_name) => {
        setWorkspaceFolderName(folder_name);
        setViewActionWorkspace(value);
        setViewActionWorkspaceId(id);
        dispatch(
            workspaces_Quick_Action_ListHandler(
                workspace_id,
                id,
                '',
                '',
                currentPage
            )
        );
    };

    const handleViewActionWorkspaceClickBack = (value, id, folder_name) => {
        setWorkspaceFolderName(folder_name);
        setViewActionWorkspace(value);
        setViewActionWorkspaceId(id);
        dispatch(
            workspaces_Quick_ActionHandler(workspace_id, '', '', currentPage)
        );
    };
    const handleClickBack = () => {
        setViewDataWorkspace(false);
        setViewDataOutWorkspace(false);
    };

    return (
        <div className='workspace-details-main'>
            <div className='workspace-title '>
                <div className='workspace-title-content'>
                    <div className='top-content'>
                        <span>
                            <img src={dollerIcon} alt='' />
                            {workspace_name} Workspace
                        </span>
                        <h4 onClick={() => Navigate('/workspaces')}>
                            <MdKeyboardBackspace />
                            Back to Workspace
                        </h4>
                    </div>

                    <div className='workspace-member'>
                        <p>
                            All team Members:
                            <span>
                                {' '}
                                {workspaceDetailsData?.team_members?.length ||
                                    0}
                            </span>
                        </p>
                        <GroupAvatar
                            maxCount={5}
                            size={45}
                            otherMember={false}
                            data={workspaceDetailsData?.team_members}
                        />
                        <AddMembers
                            workspaceDetailsData={workspaceDetailsData}
                            openModel={isOpenAddMemberPopup}
                            handleClose={() => setIsOpenAddMemberPopup(false)}
                        />

                        {workspaceDetailsData?.permissions?.includes(
                            'add-users'
                        ) ? (
                            <button
                                onClick={() => setIsOpenAddMemberPopup(true)}>
                                <FaRegUserCircle /> Add Members
                            </button>
                        ) : (
                            <button className='permision-not-allowed-css'>
                                <FaRegUserCircle /> Add Members
                            </button>
                        )}
                        <div className='Qa_workspace-count'>
                            <div>
                                {requestData ? (
                                    <div>245</div>
                                ) : (
                                    <h3 className='Qa-have-zero'>
                                        {workspaceDetailsData?.credit_remaining ||
                                            0}
                                        <Popover
                                            content={
                                                <div className='popover-lock-content'>
                                                    Your available credits have
                                                    been depleted. Kindly reach
                                                    out to your administrator to
                                                    request more credits.
                                                    {workspaceDetailsData?.permissions?.includes(
                                                        'request-credits'
                                                    ) ? (
                                                        <button
                                                            className='credit-request-content'
                                                            onClick={
                                                                CreditOverlay
                                                            }>
                                                            <BiSolidCoinStack className='fakkey' />
                                                            <span className='button-text'>
                                                                Request Credits
                                                            </span>
                                                        </button>
                                                    ) : (
                                                        <button className='credit-request-content permision-not-allowed-css'>
                                                            <BiSolidCoinStack className='fakkey' />
                                                            <span className='button-text'>
                                                                Request Credits
                                                            </span>
                                                        </button>
                                                    )}
                                                </div>
                                            }
                                            placement='bottom'>
                                            <HiOutlineInformationCircle />
                                        </Popover>
                                    </h3>
                                )}
                                <p>QA Credits remaining</p>
                            </div>
                            <div>
                                <h3> {workspaceDetailsData?.total_qa || 0}</h3>
                                <p>Total QA in this workspace</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='my-steptabs'>
                <TabsOn size={'large '} tabNames={tabNames} destroyInactiveTabPane>
                    {!viewActionWorkspace ? (
                        <WorkspacesDetailsAction
                            handleViewActionWorkspaceClick={
                                handleViewActionWorkspaceClick
                            }
                            setViewActionWorkspace={setViewActionWorkspace}
                            workspaceFolderListData={workspaceFolderListData}
                            workspaceQuickListData={workspaceQuickListData}
                            workspaceFolderListLoader={
                                workspaceFolderListLoader
                            }
                            workspaceId={workspaceDetailsData?.id}
                            workspaceName={workspaceDetailsData?.name}
                            type={workspaceDetailsData?.access_type}
                            permissionsDetails={
                                workspaceDetailsData?.permissions
                            }
                            workspaceRole={workspaceDetailsData?.workspace_role}
                        />
                    ) : (
                        <FolderAction
                            handleViewActionWorkspaceClick={
                                handleViewActionWorkspaceClick
                            }
                            handleViewActionWorkspaceClickBack={
                                handleViewActionWorkspaceClickBack
                            }
                            workspaceQuickListData={workspaceQuickListData}
                            setViewActionWorkspace={setViewActionWorkspace}
                            setViewActionWorkspaceid={setViewActionWorkspaceid}
                            workspace_id={workspace_id}
                            setworkspacefoldername={setworkspacefoldername}
                            permissionsDetails={
                                workspaceDetailsData?.permissions
                            }
                            workspaceRole={workspaceDetailsData?.workspace_role}
                        />
                    )}
                    {!viewDataWorkspace && !viewDataOutWorkspace ? (
                        <WorkspacesDetailsData
                            setViewDataWorkspace={setViewDataWorkspace}
                            setViewDataOutWorkspace={setViewDataOutWorkspace}
                            handleClick={handleClick}
                            handleClickOutPut={handleClickOutPut}
                            workspaceSupportingDocumentOutputDetailsData={
                                workspaceSupportingDocumentOutputDetailsData
                            }
                            workspaceSupportingDocumentDetailsData={
                                workspaceSupportingDocumentDetailsData
                            }
                            workspaceId={workspaceDetailsData?.id}
                            workspaceName={workspaceDetailsData?.name}
                            setworkspacefoldername={setworkspacefoldername}
                            permissionsDetails={
                                workspaceDetailsData?.permissions
                            }
                        />
                    ) : viewDataOutWorkspace ? (
                        <DataDetailsOutFolder
                            setViewDataOutWorkspace={setViewDataOutWorkspace}
                            setDatadetalisoutputid={setDatadetalisoutputid}
                            setworkspacefoldername={setworkspacefoldername}
                            permissionsDetails={
                                workspaceDetailsData?.permissions
                            }
                            handleClickBack={handleClickBack}
                        />
                    ) : (
                        <DataDetailsFolder
                            setViewDataWorkspace={setViewDataWorkspace}
                            setDatadetalisid={setDatadetalisid}
                            setworkspacefoldername={setworkspacefoldername}
                            permissionsDetails={
                                workspaceDetailsData?.permissions
                            }
                            handleClickBack={handleClickBack}
                        />
                    )}
                    <WorkspacesDetailsHistory />
                </TabsOn>
            </div>

            <Drawer
                placement='right'
                closable={false}
                onClose={CreditOverlay}
                open={openRequestCredit}
                key='right'
                width={'25%'}>
                <RequestCredit
                    workspace_id={workspace_id}
                    openRequestCredit={openRequestCredit}
                    CreditOverlay={CreditOverlay}
                />
            </Drawer>
        </div>
    );
};

export default WorkspaceDetails;
